export class IngestionPipeline {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "namespace",
            "baseName": "namespace",
            "type": "string",
            "format": ""
        },
        {
            "name": "tableName",
            "baseName": "tableName",
            "type": "string",
            "format": ""
        },
        {
            "name": "sourceType",
            "baseName": "sourceType",
            "type": "IngestionSourceType",
            "format": ""
        },
        {
            "name": "credentialsProfileId",
            "baseName": "credentialsProfileId",
            "type": "string",
            "format": ""
        },
        {
            "name": "s3SourceProperties",
            "baseName": "s3SourceProperties",
            "type": "S3SourceProperties",
            "format": ""
        },
        {
            "name": "gcsSourceProperties",
            "baseName": "gcsSourceProperties",
            "type": "GcsSourceProperties",
            "format": ""
        },
        {
            "name": "kafkaSourceProperties",
            "baseName": "kafkaSourceProperties",
            "type": "KafkaSourceProperties",
            "format": ""
        },
        {
            "name": "bucketFilesSourceProperties",
            "baseName": "bucketFilesSourceProperties",
            "type": "BucketFilesSourceProperties",
            "format": ""
        },
        {
            "name": "sinkType",
            "baseName": "sinkType",
            "type": "IngestionSinkType",
            "format": ""
        },
        {
            "name": "icebergSinkProperties",
            "baseName": "icebergSinkProperties",
            "type": "IcebergSinkProperties",
            "format": ""
        },
        {
            "name": "paimonSinkProperties",
            "baseName": "paimonSinkProperties",
            "type": "PaimonSinkProperties",
            "format": ""
        },
        {
            "name": "computeSize",
            "baseName": "computeSize",
            "type": "IngestionComputeSize",
            "format": ""
        },
        {
            "name": "maxParallelism",
            "baseName": "maxParallelism",
            "type": "number",
            "format": ""
        },
        {
            "name": "slotsPerTm",
            "baseName": "slotsPerTm",
            "type": "number",
            "format": ""
        },
        {
            "name": "initialTmCount",
            "baseName": "initialTmCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "maxTmCount",
            "baseName": "maxTmCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "catalogId",
            "baseName": "catalogId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "warehouseSubpath",
            "baseName": "warehouseSubpath",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "IngestionPipelineStatus",
            "format": ""
        },
        {
            "name": "observedStatus",
            "baseName": "observedStatus",
            "type": "string",
            "format": ""
        },
        {
            "name": "lastObservation",
            "baseName": "lastObservation",
            "type": "IngestionPipelineLastObservation",
            "format": ""
        },
        {
            "name": "failureMessage",
            "baseName": "failureMessage",
            "type": "string",
            "format": ""
        },
        {
            "name": "gcsRouterTopicId",
            "baseName": "gcsRouterTopicId",
            "type": "string",
            "format": ""
        },
        {
            "name": "maxPartitions",
            "baseName": "maxPartitions",
            "type": "number",
            "format": ""
        },
        {
            "name": "detectedPartitionCount",
            "baseName": "detectedPartitionCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "createdAt",
            "baseName": "createdAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "updatedAt",
            "baseName": "updatedAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return IngestionPipeline.attributeTypeMap;
    }
    constructor() {
    }
}
